import { BaseClient, IActionResponse, IActionResult } from "../";
import { LookupModuleRouteMap, Module } from "../../../assets/types/common";
import { ApiParams, IPagedResult, SearchDto } from "../../../assets/utils/lib";
import { DropdownOption } from "../../../assets/vfx/controls/components/dropdown/controlDropdown";

export class LookupGroupClient<T> extends BaseClient {

    routes: string[] = [];
    constructor(moduleType: Module) {
        super();
        this.routes = [LookupModuleRouteMap[moduleType], "configuration"];
    }

    async getLookupGroupAsync(id?: string | undefined): Promise<T> {
        const actions: string[] = ["GetLookupGroup"];
        const params: ApiParams[] = [
            new ApiParams("groupId", id, true)
        ];

        return await this.getAsync<T>(actions, params);
    }

    async getLookupGroupsAsync(lookupTypeId?: string | undefined): Promise<T[]> {
        const actions: string[] = ["GetCategoryLookupGroups"];
        const params: ApiParams[] = [
            new ApiParams("categoryId", lookupTypeId, true),
        ];

        return await this.getAsync<T[]>(actions, params);
    }

    async searchLookupGroupsAsync(searchDto: SearchDto): Promise<IPagedResult<T>> {
        const actions: string[] = ["SearchLookupGroup"];
        return await this.postAsync<SearchDto, T, IPagedResult<T>>(actions, searchDto);
    }

    async saveLookupGroupAsync(payload?: T | undefined): Promise<IActionResult<T>> {
        const actions: string[] = ["SaveLookupGroup"];
        return await this.postAsync<T>(actions, payload);
    }

    async deleteLookupGroupAsync(id?: string | undefined): Promise<IActionResponse> {
        const actions: string[] = ["DeleteLookupGroup"];
        const params: ApiParams[] = [
            new ApiParams("groupId", id, true)
        ];

        return await this.deleteAsync(actions, params);
    }

    async getLookupGroupsAsLookupAsync(lookupTypeId: string): Promise<DropdownOption[]> {
        const result = await this.getLookupGroupsAsync(lookupTypeId);
        const transformedData: DropdownOption[] = result?.map((lookupCategory: any) => ({
            display: lookupCategory.name as string,
            value: lookupCategory.id as string,
            key: lookupCategory.id as string
        }));

        return transformedData;
    }

}